/** Roles com o mesmo nível de acesso de usuário comum (não analista/admin/gerente). */
export type EndUserRole = 'usuario';

export function isEndUserRole(role?: string | null): boolean {
  return role === 'usuario';
}

/**
 * Permite requisitante ser aprovador quando o admin liberou a flag
 * (qualquer role; só o admin seta isso na tela de usuários).
 */
export function userMayBeRequesterAndApprover(user?: {
  role?: string | null;
  can_be_requester_approver?: boolean | null;
} | null): boolean {
  return !!user?.can_be_requester_approver;
}
